// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { DataChangeTrigger } from "./data-change-trigger";
import { DeadbandType } from "./deadband-type";
import { MonitoringMode } from "./monitoring-mode";

/**
 * Per-monitored-item parameters (data-change filter + queueing).
 */
export class MonitoringParameters implements flatbuffers.IUnpackableObject<MonitoringParametersT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): MonitoringParameters {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsMonitoringParameters(
    bb: flatbuffers.ByteBuffer,
    obj?: MonitoringParameters,
  ): MonitoringParameters {
    return (obj || new MonitoringParameters()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsMonitoringParameters(
    bb: flatbuffers.ByteBuffer,
    obj?: MonitoringParameters,
  ): MonitoringParameters {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new MonitoringParameters()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  /**
   * Item sampling interval; -1 = use the subscription's interval, 0 = fastest.
   */
  samplingIntervalMs(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : -1.0;
  }

  /**
   * Server-side queue depth for this item.
   */
  queueSize(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 1;
  }

  /**
   * Discard the oldest queued value when the queue overflows.
   */
  discardOldest(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true;
  }

  monitoringMode(): MonitoringMode {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MonitoringMode.Reporting;
  }

  dataChangeTrigger(): DataChangeTrigger {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DataChangeTrigger.StatusValue;
  }

  deadbandType(): DeadbandType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeadbandType.None_;
  }

  /**
   * Deadband magnitude (absolute units, or percent of EU range).
   */
  deadbandValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
  }

  static startMonitoringParameters(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addSamplingIntervalMs(builder: flatbuffers.Builder, samplingIntervalMs: number) {
    builder.addFieldFloat64(0, samplingIntervalMs, -1.0);
  }

  static addQueueSize(builder: flatbuffers.Builder, queueSize: number) {
    builder.addFieldInt32(1, queueSize, 1);
  }

  static addDiscardOldest(builder: flatbuffers.Builder, discardOldest: boolean) {
    builder.addFieldInt8(2, +discardOldest, +true);
  }

  static addMonitoringMode(builder: flatbuffers.Builder, monitoringMode: MonitoringMode) {
    builder.addFieldInt8(3, monitoringMode, MonitoringMode.Reporting);
  }

  static addDataChangeTrigger(builder: flatbuffers.Builder, dataChangeTrigger: DataChangeTrigger) {
    builder.addFieldInt8(4, dataChangeTrigger, DataChangeTrigger.StatusValue);
  }

  static addDeadbandType(builder: flatbuffers.Builder, deadbandType: DeadbandType) {
    builder.addFieldInt8(5, deadbandType, DeadbandType.None_);
  }

  static addDeadbandValue(builder: flatbuffers.Builder, deadbandValue: number) {
    builder.addFieldFloat64(6, deadbandValue, 0.0);
  }

  static endMonitoringParameters(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createMonitoringParameters(
    builder: flatbuffers.Builder,
    samplingIntervalMs: number,
    queueSize: number,
    discardOldest: boolean,
    monitoringMode: MonitoringMode,
    dataChangeTrigger: DataChangeTrigger,
    deadbandType: DeadbandType,
    deadbandValue: number,
  ): flatbuffers.Offset {
    MonitoringParameters.startMonitoringParameters(builder);
    MonitoringParameters.addSamplingIntervalMs(builder, samplingIntervalMs);
    MonitoringParameters.addQueueSize(builder, queueSize);
    MonitoringParameters.addDiscardOldest(builder, discardOldest);
    MonitoringParameters.addMonitoringMode(builder, monitoringMode);
    MonitoringParameters.addDataChangeTrigger(builder, dataChangeTrigger);
    MonitoringParameters.addDeadbandType(builder, deadbandType);
    MonitoringParameters.addDeadbandValue(builder, deadbandValue);
    return MonitoringParameters.endMonitoringParameters(builder);
  }

  unpack(): MonitoringParametersT {
    return new MonitoringParametersT(
      this.samplingIntervalMs(),
      this.queueSize(),
      this.discardOldest(),
      this.monitoringMode(),
      this.dataChangeTrigger(),
      this.deadbandType(),
      this.deadbandValue(),
    );
  }

  unpackTo(_o: MonitoringParametersT): void {
    _o.samplingIntervalMs = this.samplingIntervalMs();
    _o.queueSize = this.queueSize();
    _o.discardOldest = this.discardOldest();
    _o.monitoringMode = this.monitoringMode();
    _o.dataChangeTrigger = this.dataChangeTrigger();
    _o.deadbandType = this.deadbandType();
    _o.deadbandValue = this.deadbandValue();
  }

  unpackFields(...fields: string[]): MonitoringParametersT {
    const t = new MonitoringParametersT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("sampling_interval_ms")) {
      t.samplingIntervalMs = this.samplingIntervalMs();
    }
    if (fieldSet.has("queue_size")) {
      t.queueSize = this.queueSize();
    }
    if (fieldSet.has("discard_oldest")) {
      t.discardOldest = this.discardOldest();
    }
    if (fieldSet.has("monitoring_mode")) {
      t.monitoringMode = this.monitoringMode();
    }
    if (fieldSet.has("data_change_trigger")) {
      t.dataChangeTrigger = this.dataChangeTrigger();
    }
    if (fieldSet.has("deadband_type")) {
      t.deadbandType = this.deadbandType();
    }
    if (fieldSet.has("deadband_value")) {
      t.deadbandValue = this.deadbandValue();
    }
    return t;
  }
}

export class MonitoringParametersT implements flatbuffers.IGeneratedObject {
  constructor(
    public samplingIntervalMs: number = -1.0,
    public queueSize: number = 1,
    public discardOldest: boolean = true,
    public monitoringMode: MonitoringMode = MonitoringMode.Reporting,
    public dataChangeTrigger: DataChangeTrigger = DataChangeTrigger.StatusValue,
    public deadbandType: DeadbandType = DeadbandType.None_,
    public deadbandValue: number = 0.0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return MonitoringParameters.createMonitoringParameters(
      builder,
      this.samplingIntervalMs,
      this.queueSize,
      this.discardOldest,
      this.monitoringMode,
      this.dataChangeTrigger,
      this.deadbandType,
      this.deadbandValue,
    );
  }

  clone(): MonitoringParametersT {
    const obj = new MonitoringParametersT();
    obj.samplingIntervalMs = this.samplingIntervalMs;
    obj.queueSize = this.queueSize;
    obj.discardOldest = this.discardOldest;
    obj.monitoringMode = this.monitoringMode;
    obj.dataChangeTrigger = this.dataChangeTrigger;
    obj.deadbandType = this.deadbandType;
    obj.deadbandValue = this.deadbandValue;
    return obj;
  }

  equals(other: MonitoringParametersT): boolean {
    if (!Object.is(this.samplingIntervalMs, other.samplingIntervalMs)) return false;
    if (this.queueSize !== other.queueSize) return false;
    if (this.discardOldest !== other.discardOldest) return false;
    if (this.monitoringMode !== other.monitoringMode) return false;
    if (this.dataChangeTrigger !== other.dataChangeTrigger) return false;
    if (this.deadbandType !== other.deadbandType) return false;
    if (!Object.is(this.deadbandValue, other.deadbandValue)) return false;
    return true;
  }
}

export function verifyMonitoringParameters(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 8);
    verifier.checkScalarField(tablePos, 6, 4);
    verifier.checkScalarField(tablePos, 8, 1);
    verifier.checkScalarField(tablePos, 10, 1);
    verifier.checkScalarField(tablePos, 12, 1);
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 8);
  } finally {
    verifier.popDepth();
  }
}
